// Relative imports
import { addQueryParams, axiosInstance } from "./common.jsx";

// Tasks
export const listTasksOfService = async (service_id, queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || `tasks/${service_id}/tasks/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createTaskWithWizard = async (service_id, data) => {
  const endpoint = `services/wizard/service/${service_id}/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createTask = async (service_id, data) => {
  const endpoint = `tasks/${service_id}/tasks/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getTask = async (task_id) => {
  const endpoint = `tasks/${task_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateTask = async (task_id, data) => {
  const endpoint = `tasks/${task_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteTask = async (task_id) => {
  const endpoint = `tasks/${task_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// SubTasks
export const listSubTasks = async (task_id, queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || `tasks/${task_id}/subtasks/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createSubTask = async (task_id, data) => {
  const endpoint = `tasks/${task_id}/subtasks/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getSubTask = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateSubTask = async (subtask_id, data) => {
  const endpoint = `tasks/subtasks/${subtask_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteSubTask = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Operator SubTasks
export const listOperatorSubTasks = async (operator_id, queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || `tasks/subtasks/operator/${operator_id}/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Operator Tasks
export const listOperatorTasks = async (operator_id, queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || `tasks/operator/${operator_id}/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Company SubTasks
export const listCompanySubTasksTaskboard = async (
  company_id,
  queryParams = {},
  newEndpoint = null
) => {
  let endpoint = newEndpoint || `tasks/subtasks/company/${company_id}/taskboard/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const listCompanySubTasksTable = async (
  company_id,
  queryParams = {},
  newEndpoint = null
) => {
  let endpoint = newEndpoint || `tasks/subtasks/company/${company_id}/table/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// SubTask Activities
export const listSubTaskActivities = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/activity/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createSubTaskActivity = async (subtask_id, data) => {
  const endpoint = `tasks/subtasks/${subtask_id}/activity/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateSubTaskActivity = async (subtask_id, subtask_activity_id, data) => {
  const endpoint = `tasks/subtasks/${subtask_id}/activity/${subtask_activity_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteSubTaskActivity = async (subtask_id, subtask_activity_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/activity/${subtask_activity_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const listSubTaskAttachments = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/attachments/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createSubTaskAttachment = async (subtask_id, data) => {
  const endpoint = `tasks/subtasks/${subtask_id}/attachments/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteSubTaskAttachment = async (subtask_id, media_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/attachments/${media_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const bulkUpdateTask = async (data) => {
  const endpoint = `tasks/bulk-update/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const bulkUpdateSubTask = async (data) => {
  const endpoint = `tasks/subtasks/bulk-update/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const bulkCreateSubtasks = async (data) => {
  const endpoint = `tasks/subtasks/bulk-create/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// ---------------------------------------------------------------------------
// Multi-shop subtask fan-out (linked copies)
// ---------------------------------------------------------------------------

// Create linked copies of a subtask on other companies (shops).
// data: {
//   targets: [{ company_id, task_id?, due_date? }],
//   auto_create_target: bool, copy_operators: bool,
//   copy_labels: bool, copy_dates: bool
// }
// Partial success is returned as 2xx with `skipped[]`.
export const fanOutSubtask = async (subtask_id, data) => {
  const endpoint = `tasks/subtasks/${subtask_id}/fanout/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// List the link group of a subtask: { source, copies: [...] }
export const listSubtaskLinkGroup = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/linked/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// Detach a copy from its source (idempotent)
export const detachSubtaskFromGroup = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/detach/`;
  return axiosInstance
    .post(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// Relink a detached copy to its source (undo of the detach)
export const relinkSubtaskToGroup = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/relink/`;
  return axiosInstance
    .post(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// Force a full resync of the linked copies from the source
export const resyncSubtaskLinkGroup = async (subtask_id) => {
  const endpoint = `tasks/subtasks/${subtask_id}/resync/`;
  return axiosInstance
    .post(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
